// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { polygonMumbai as _polygonMumbai } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the polygonMumbai chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 80001
 * Chain Name: Polygon Mumbai
 * Default Block Explorer: https://mumbai.polygonscan.com
 * Default RPC URL: https://rpc.ankr.com/polygon_mumbai
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { polygonMumbai } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: polygonMumbai,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const polygonMumbai = createCommon({
	..._polygonMumbai,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
